import { render, staticRenderFns } from "./RatingSummaryCompactItem.vue?vue&type=template&id=53c7d1bf&scoped=true&"
import script from "./RatingSummaryCompactItem.vue?vue&type=script&lang=js&"
export * from "./RatingSummaryCompactItem.vue?vue&type=script&lang=js&"
import style0 from "./RatingSummaryCompactItem.vue?vue&type=style&index=0&id=53c7d1bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c7d1bf",
  null
  
)

export default component.exports